import { VidioHelpers } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';
const Cookies = require('js-cookie');

export default class SearchTracker{
  constructor(options) {
    this.$element = $(options.element);

    this.tab = this.$element.data("tab");
    this.page = this.$element.data("page");
    this.keyword = this.$element.data("keyword");
    this.keyword_type = this.$element.data("keyword-type");

    this.eventBody = $.Event("impression::search");
    this.eventBody.tab = this.tab;
    this.eventBody.results = this.results;
    this.eventBody.page = this.page;
  }

  init(){
    this.sendImpression();
  }

  defineKeywordType(){
    return this.keyword_type === "PopularKeyword" ? 'trending': this.keyword_type === "AutoSuggest" ? 'suggestion': 'text';
  }

  generateImpressionProperties() {
    var dateFormat = require('dateformat');
    var properties = {
      search_uuid: Cookies.get("search_uuid"),
      referrer : VidioHelpers.getReferrer(),
      action: 'search',
      section: this.tab,
      keyword: this.keyword,
      keyword_type: this.defineKeywordType(),
      result: {
        'video_id': this.getItems("video"),
        'user_id': this.getItems("user"),
        'collection_id': this.getItems("collection"),
        'tag': this.getItems("tag"),
      },
      event_time: dateFormat(new Date().UTC, "yyyy-mm-dd HH:MM:ss")
    };
    return properties;
  }

  sendImpression() {
    AhoyEvent.send("VIDIO::SEARCH", this.generateImpressionProperties());
  }

  getItems(component){
    var search_result = $('.js-search-tracker').find("[data-"+component+"-id]");
    var items = [];
    search_result.each(function (index, object) {
      items.push($(object).data(component+"-id"));
    });
    return items;
  }

}
